import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ProductItemFlowContainer = Box.withConfig({
  width: 'full',
  backgroundColor: primitive.$white,
});
